import React, { createContext, useContext, useState } from "react";

// Global "Business Mode" (owner-only). When ON (toggled from the top-nav
// Business button), business-facing tools appear — e.g. per-game expected
// revenue on the Schedule. Mirrors AdminModeContext.
const Ctx = createContext(null);

export function BusinessModeProvider({ children }) {
    const [businessMode, setBusinessMode] = useState(false);
    return (
        <Ctx.Provider value={{ businessMode, setBusinessMode, toggle: () => setBusinessMode((v) => !v) }}>
            {children}
        </Ctx.Provider>
    );
}

export function useBusinessMode() {
    return useContext(Ctx) || { businessMode: false, setBusinessMode: () => {}, toggle: () => {} };
}
